import { useContext } from "react";

import { RightBarContext } from "./RightBarProvider";

export const useRightBarContext = (): RightBarContext => useContext(RightBarContext);
